// extracted by mini-css-extract-plugin
export default {"fakeDisabled":"withTooltip_fakeDisabled__DABxO","tooltip":"withTooltip_tooltip__aMOLA","basePadding":"withTooltip_basePadding__-noiw"};